import {
  appendResponse,
  type ResponseId,
} from "@bindery/shared/contracts/fluency";
import type { FluencyRow, OutboxResponseRow } from "@/storage/db";

/** The server's history with this word's unacknowledged responses on top. */
export function replayPending(
  serverHistory: readonly ResponseId[],
  pending: readonly Pick<
    OutboxResponseRow,
    "response" | "occurredAt" | "queuedAt"
  >[],
): ResponseId[] {
  return [...pending]
    .sort((a, b) => a.occurredAt - b.occurredAt || a.queuedAt - b.queuedAt)
    .reduce<ResponseId[]>(
      (history, row) => appendResponse(history, row.response as ResponseId),
      [...serverHistory],
    );
}

export function withServerHistory(
  readerId: string,
  word: string,
  serverHistory: readonly ResponseId[],
  lastUpdated: number,
  pending: readonly OutboxResponseRow[],
): FluencyRow {
  return {
    readerId,
    word,
    serverHistory: [...serverHistory],
    history: replayPending(serverHistory, pending),
    lastUpdated,
  };
}
